import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getEstaciones,
  deleteEstacion,
  getEstacionById,
} from "../helpers/rutaEstaciones";
import ModalEstacion from "./ModalEstacion";
import "../css/tableclientes.css";

const TableEstaciones = () => {
  const [estaciones, setEstaciones] = useState({
    data: {},
    loading: true,
  });

  const [estacion, setEstacion] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaEstaciones();
  }, []);

  const consultaEstaciones = () => {
    getEstaciones().then((datos) => {
      console.log("📦 Estaciones:", datos);

      setEstaciones({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaEstaciones();
  };

  const handleShow = () => setShow(true);

  const modificaEstacion = (id) => {
    getEstacionById(id).then((resp) => {
      if (resp.ok) {
        setEstacion(resp.estacion);
        handleShow();
      } else {
        console.error("❌ Error al obtener estación:", resp.error);
      }
    });
  };

  const eliminarEstacion = (id) => {
    const confirmar = window.confirm(
      "¿Está seguro que desea borrar la estación / proveedor de combustible?"
    );

    if (confirmar) {
      deleteEstacion(id).then(() => {
        consultaEstaciones();
      });
    }
  };

  const listaEstaciones = estaciones.data?.estaciones || [];

  const tdSmall = {
    fontSize: "11px",
    verticalAlign: "middle",
  };

  const tdCenter = {
    ...tdSmall,
    textAlign: "center",
  };

  const tdNoWrap = {
    ...tdSmall,
    whiteSpace: "nowrap",
  };

  return (
    <div className="table-container">
      {!estaciones.loading && (
        <>
          <div className="col-12 mt-4" />

          <div>
            <Table
              striped
              bordered
              hover
              responsive
              className="table-container"
              style={{
                tableLayout: "fixed",
                minWidth: "1150px",
                fontSize: "11px",
              }}
            >
              <colgroup>
                <col style={{ width: "70px" }} />   {/* Acciones */}
                <col style={{ width: "45px" }} />   {/* Nro */}
                <col style={{ width: "210px" }} />  {/* Estación */}
                <col style={{ width: "150px" }} />  {/* Lugar */}
                <col style={{ width: "170px" }} />  {/* Domicilio */}
                <col style={{ width: "100px" }} />  {/* Teléfono */}
                <col style={{ width: "110px" }} />  {/* CUIT */}
                <col style={{ width: "150px" }} />  {/* Tipo */}
                <col style={{ width: "80px" }} />   {/* Cta Cte */}
                <col style={{ width: "180px" }} />  {/* Observaciones */}
              </colgroup>

              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th>Estación / Proveedor</th>
                  <th>Lugar</th>
                  <th>Domicilio</th>
                  <th>Teléfono</th>
                  <th>CUIT</th>
                  <th>Tipo</th>
                  <th>Cta. Cte.</th>
                  <th>Observaciones</th>
                </tr>
              </thead>

              <tbody>
                {listaEstaciones.map((estacion) =>
                  estacion.activo ? (
                    <tr key={estacion._id}>
                      <td style={tdCenter}>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => modificaEstacion(estacion._id)}
                          title="Modificar"
                          style={{ padding: "2px 6px", marginRight: "4px" }}
                        >
                          <i
                            className="fa fa-pencil-square-o"
                            aria-hidden="true"
                          />
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => eliminarEstacion(estacion._id)}
                          title="Eliminar"
                          style={{ padding: "2px 6px" }}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>

                      <td style={tdCenter}>{estacion.codest}</td>

                      <td
                        style={{
                          ...tdSmall,
                          fontWeight: "600",
                          whiteSpace: "normal",
                          lineHeight: "1.25",
                        }}
                      >
                        {estacion.estacion}
                      </td>

                      <td style={tdSmall}>{estacion.lugar}</td>

                      <td style={tdSmall}>{estacion.domicilio || "-"}</td>

                      <td style={tdNoWrap}>{estacion.telefono || "-"}</td>

                      <td style={tdNoWrap}>{estacion.cuit || "-"}</td>

                      <td style={tdCenter}>
                        {estacion.tipoEstacion || "ESTACION"}
                      </td>

                      <td style={tdCenter}>
                        {estacion.permiteCuentaCorriente ? "SI" : "NO"}
                      </td>

                      <td style={tdSmall}>{estacion.observaciones || "-"}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>

          <ModalEstacion
            show={show}
            handleClose={handleClose}
            estacion={estacion}
          />
        </>
      )}
    </div>
  );
};

export default TableEstaciones;